import { useState } from "react";
import Header from "../../reusable/Header";
import PoweredBy from "../../reusable/PoweredBy";
import DynamicForm from "./DynamicForm";

function GovernmentDatabaseDynamicForm({
  database,
  country,
  goBack,
  onSubmit,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = (formData) => {
    setIsSubmitting(true);
    onSubmit([
      {
        document: null,
        field: {
          fieldName: "GOVERNMENT_CHECK_DATA",
          fileName: null,
          type: database.id,
          country: country.countryCode,
          value: JSON.stringify(formData),
        },
      },
    ]);
  };

  return (
    <div className="flex h-full flex-col">
      {/* Fixed Header */}
      <div className="top-0 left-0">
        <Header goBack={goBack} />
        <div className="mb-5 text-center flex flex-col">
          <div className="font-medium text-xl" style={{color: "var(--urtentic-sdk-title, #000000)"}}>{database?.name}</div>
          <div className="flex flex-row justify-center">
            <div className="flex flex-row p-1 gap-2 bg-white items-center">
              <img
                src={country?.countryFlag}
                alt={country?.countryName}
                className="w-6 h-4 object-cover rounded-sm"
              />
              <div className="desc">{country?.countryName}</div>
            </div>
          </div>
          <div className="desc text-sm mt-2 px-4">
            {database?.description}
          </div>
        </div>
      </div>

      {/* Dynamic Form */}
      <DynamicForm
        inputs={database?.input}
        onSubmit={handleFormSubmit}
        isLoading={isSubmitting}
      />

      {/* Fixed Footer */}
      <div className="flex justify-center p-2">
        <PoweredBy />
      </div>
    </div>
  );
}

export default GovernmentDatabaseDynamicForm;
